import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'

import { Allowance } from '../../../_common/useReportAllowances'
import { AllSchoolsAllowancesDto } from '../../../_common/useReportAllSchoolsAllowancesDto'
import { TotalsDto } from '../../../_common/useReportTotalsDto'
import { useByAllowancesTableData } from './useByAllowancesTableData'

type Props = {
  allowances: Array<Allowance>
  allSchoolsAllowancesDto: AllSchoolsAllowancesDto
  totalsDto: TotalsDto
}

export const ByAllowancesTable = ({ allowances, allSchoolsAllowancesDto, totalsDto }: Props) => {
  const tableData = useByAllowancesTableData({ allowances, allSchoolsAllowancesDto, totalsDto })

  return (
    <CompositeTableTemplate
      data={tableData}
      renderCell={renderCellGrayZeros}
      renderFooterCell={renderCellGrayZeros}
    />
  )
}
